import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class AgroVisitaItemValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, tipoocorrenciaSelected, refs) {
        let validated = true;

        if (Util.isNull(tipoocorrenciaSelected)) {
            refs.tipoocorrenciaSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idagro_ocorrencia)) {
            refs.ocorrenciaSelect.focusedOut = true;
            validated = false;
        }
        
        if (Util.isNull(model.quebrasafra)) {
            refs.quebrasafraInput.focusedOut = true;
            validated = false;
        }
        
        return validated;
    }

}